import { use } from 'react';
import ActivityBookingContext from '..';
const useActivityBookingAvailableTariffs = () => {
    const { availableTariffs } = use(ActivityBookingContext);
    return availableTariffs;
};
export default useActivityBookingAvailableTariffs;
